import img1 from '@@assets/imgs/galery/IMG_8277.jpg';
import img2 from '@@assets/imgs/galery/IMG_8278.jpg';
import img3 from '@@assets/imgs/galery/IMG_8279.jpg';
import img4 from '@@assets/imgs/galery/IMG_8281.jpg';
import img5 from '@@assets/imgs/galery/IMG_8285.jpg';
import img6 from '@@assets/imgs/galery/IMG_8287.jpg';
import clx from '@@components/page/home/clx';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

/**
 * Component: ImagesSection
 * TODO: image links
 */
const ImagesSection = () => {
  const t = useTranslations('headers');

  return (
    <section className={clx('section')}>
      <h2>{t('imgs')}</h2>

      <div className={clx('images-section')}>
        <Image className={clx('image')} src={img1} loading="lazy" placeholder="blur" alt="galery-image" />
        <Image className={clx('image')} src={img2} loading="lazy" placeholder="blur" alt="galery-image" />
        <Image className={clx('image')} src={img3} loading="lazy" placeholder="blur" alt="galery-image" />
        <Image className={clx('image')} src={img4} loading="lazy" placeholder="blur" alt="galery-image" />
        <Image className={clx('image')} src={img5} loading="lazy" placeholder="blur" alt="galery-image" />
        <Image className={clx('image')} src={img6} loading="lazy" placeholder="blur" alt="galery-image" />

        {/* {GaleryImages.map((img, i) => (
          <img
            className="max-h-[75dvh] min-h-[25vh] min-w-full rounded-md object-cover ring-2 ring-orange-300" //
            src={'/galery/' + img}
            loading="lazy"
            alt={img}
            key={i}
          />
        ))} */}
      </div>
    </section>
  );
};
export default ImagesSection;
